import { render, staticRenderFns } from "./_base-no-item-selected.vue?vue&type=template&id=5fe5c2c9&"
import script from "./_base-no-item-selected.vue?vue&type=script&lang=js&"
export * from "./_base-no-item-selected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports